import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "antd/es/divider/style";
import _Divider from "antd/es/divider";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["columns", "layoutType", "steps", "type", "action", "formRef"];

/* eslint-disable react/no-array-index-key */
import React, { useCallback, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { ProFormFieldSet, ProFormDependency } from '../../index';
import { ProFormGroup, ProFormField } from '../../index';
import { LabelIconTip, omitUndefined } from '@ant-design/pro-utils';
import { runFunction } from '@ant-design/pro-utils';
import omit from 'omit.js';
import ProForm, { DrawerForm, ModalForm, QueryFilter, LightFilter, StepsForm } from '../../index';
import ProFormList from '../List';
var FormComments = {
  DrawerForm: DrawerForm,
  QueryFilter: QueryFilter,
  LightFilter: LightFilter,
  StepForm: StepsForm.StepForm,
  StepsForm: StepsForm,
  ModalForm: ModalForm
};

var noop = function noop() {};
/**
 * 此组件可以根据 Json Schema 来生成相应的表单,大部分配置与 antd 的 table 列配置相同
 *
 * @see 此组件仍为 beta 版本，api 可能发生变化
 */


function BetaSchemaForm(props) {
  var columns = props.columns,
      _props$layoutType = props.layoutType,
      layoutType = _props$layoutType === void 0 ? 'ProForm' : _props$layoutType,
      _props$steps = props.steps,
      steps = _props$steps === void 0 ? [] : _props$steps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'form' : _props$type,
      action = props.action,
      propsFormRef = props.formRef,
      rest = _objectWithoutProperties(props, _excluded);

  var Form = FormComments[layoutType] || ProForm;

  var _useState = useState(rest.current),
      _useState2 = _slicedToArray(_useState, 2),
      stepCurrent = _useState2[0],
      setStepCurrent = _useState2[1];

  var formRef = useRef(props.form);
  var refMap = useMemo(function () {
    var obj = {
      form: formRef.current
    };
    Object.defineProperty(obj, 'form', {
      get: function get() {
        return formRef.current || {
          getFieldValue: noop,
          getFieldsValue: noop,
          resetFields: noop,
          setFieldsValue: noop
        };
      }
    });
    return obj;
  }, []);

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      updateTime = _useState4[0],
      updateFormRender = _useState4[1];

  useImperativeHandle(propsFormRef, function () {
    return refMap.form;
  }, // fix StepsForm formRef not change
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [stepCurrent]);
  /**
   * 生成子项，方便被 table 接入
   *
   * @param items
   */

  var genItems = useCallback(function (items, update) {
    if (layoutType === 'StepsForm') return [];
    return items.filter(function (originItem) {
      if (originItem.hideInForm && type === 'form') {
        return false;
      }

      return true;
    }).sort(function (a, b) {
      if (b.order || a.order) {
        return (b.order || 0) - (a.order || 0);
      }

      return (b.index || 0) - (a.index || 0);
    }).map(function (originItem, index) {
      var _item$dataIndex;

      var title = runFunction(originItem.title, originItem, 'form', /*#__PURE__*/React.createElement(LabelIconTip, {
        label: originItem.title,
        tooltip: originItem.tooltip || originItem.tip
      }));
      var item = omitUndefined({
        name: originItem.name,
        valueType: runFunction(originItem.valueType, {}),
        key: originItem.key,
        columns: originItem.columns,
        fieldProps: runFunction(originItem.fieldProps, refMap.form, originItem),
        valueEnum: originItem.valueEnum,
        dataIndex: originItem.key || originItem.dataIndex,
        initialValue: originItem.initialValue,
        formItemProps: runFunction(originItem.formItemProps, refMap.form, originItem),
        width: originItem.width,
        render: originItem.render,
        renderFormItem: originItem.renderFormItem,
        index: originItem.index,
        readonly: originItem.readonly,
        transform: originItem.transform,
        colSize: originItem.colSize,
        className: originItem.className,
        renderText: originItem.renderText,
        request: originItem.request,
        params: originItem.params,
        tooltip: originItem.tooltip || originItem.tip,
        title: title,
        dependencies: originItem.dependencies,
        proFieldProps: originItem.proFieldProps
      }); // 几种特殊的 value 不处理

      if (item.valueType && typeof item.valueType === 'string' && ['index', 'indexBorder', 'option'].includes(item === null || item === void 0 ? void 0 : item.valueType)) {
        return null;
      }

      var key = item.key || ((_item$dataIndex = item.dataIndex) === null || _item$dataIndex === void 0 ? void 0 : _item$dataIndex.toString()) || index;

      if (item.valueType === 'group') {
        if (!item.columns || !Array.isArray(item.columns)) return null;
        return /*#__PURE__*/React.createElement(ProFormGroup, _extends({
          key: key,
          label: title
        }, item.fieldProps), genItems(item.columns));
      }

      if (item.valueType === 'formList' && item.dataIndex) {
        if (!item.columns || !Array.isArray(item.columns)) return null;
        return /*#__PURE__*/React.createElement(ProFormList, _extends({
          key: key,
          name: item.dataIndex,
          label: item.title,
          initialValue: item.initialValue
        }, item.fieldProps), genItems(item.columns));
      }

      if (item.valueType === 'formSet' && item.dataIndex) {
        if (!item.columns || !Array.isArray(item.columns)) return null;
        return /*#__PURE__*/React.createElement(ProFormFieldSet, _extends({}, item.formItemProps, {
          key: key,
          initialValue: item.initialValue,
          name: item.dataIndex,
          label: item.title
        }, item.fieldProps), genItems(item.columns, update));
      }
      /** 分割线 */


      if (item.valueType === 'divider') {
        return /*#__PURE__*/React.createElement(_Divider, _extends({}, item.fieldProps, {
          key: index
        }));
      }
      /** ProFormDependency */


      if (item.valueType === 'dependency') {
        return /*#__PURE__*/React.createElement(ProFormDependency, _extends({}, item.fieldProps, {
          key: key
        }), function (values) {
          if (!item.columns || typeof item.columns !== 'function') return null;
          return genItems(item.columns(values));
        });
      }
      /** 公用的 类型 props */


      var formFieldProps = _objectSpread(_objectSpread({
        label: item.title
      }, omit(item, ['dataIndex', 'width', 'render', 'renderFormItem', 'renderText', 'title'])), {}, {
        key: key,
        name: item.dataIndex,
        width: item.width,
        formItemProps: item.formItemProps,
        fieldProps: item.fieldProps,
        render: (item === null || item === void 0 ? void 0 : item.render) ? function (dom, entity, renderIndex) {
          var _item$render;

          return item === null || item === void 0 ? void 0 : (_item$render = item.render) === null || _item$render === void 0 ? void 0 : _item$render.call(item, dom, entity, renderIndex, action === null || action === void 0 ? void 0 : action.current, _objectSpread({
            type: type
          }, item));
        } : undefined
      });

      var defaultRender = function defaultRender() {
        return /*#__PURE__*/React.createElement(ProFormField, _extends({}, formFieldProps, {
          ignoreFormItem: true
        }));
      };

      if (item === null || item === void 0 ? void 0 : item.renderFormItem) {
        var _item$renderFormItem;

        var formDom = item === null || item === void 0 ? void 0 : (_item$renderFormItem = item.renderFormItem) === null || _item$renderFormItem === void 0 ? void 0 : _item$renderFormItem.call(item, _objectSpread(_objectSpread({
          type: type
        }, item), {}, {
          originProps: originItem
        }), _objectSpread(_objectSpread({}, item), {}, {
          defaultRender: defaultRender,
          type: type
        }), refMap.form);

        if (formDom === false || formDom === undefined || formDom === null) {
          return null;
        }
      }

      return /*#__PURE__*/React.createElement(ProFormField, _extends({}, formFieldProps, {
        // eslint-disable-next-line react/no-array-index-key
        key: "".concat(key, "-").concat(index),
        transform: item.transform,
        renderFormItem: (item === null || item === void 0 ? void 0 : item.renderFormItem) ? function (_, config) {
          var _item$renderFormItem2;

          var renderConfig = omitUndefined(_objectSpread(_objectSpread({}, config), {}, {
            onChange: undefined
          }));
          return item === null || item === void 0 ? void 0 : (_item$renderFormItem2 = item.renderFormItem) === null || _item$renderFormItem2 === void 0 ? void 0 : _item$renderFormItem2.call(item, _objectSpread(_objectSpread({
            type: type
          }, item), {}, {
            originProps: originItem
          }), _objectSpread(_objectSpread({}, renderConfig), {}, {
            defaultRender: defaultRender,
            type: type
          }), refMap.form);
        } : undefined
      }));
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [action, layoutType, type]);
  var needRealUpdate = useMemo(function () {
    if (layoutType === 'StepsForm') return [];
    return columns.some(function (item) {
      return item.renderFormItem || typeof item.fieldProps === 'function' || typeof item.formItemProps === 'function';
    });
  }, [columns, layoutType]);

  var onCurrentChange = function onCurrentChange(current) {
    var _rest$onCurrentChange;

    (_rest$onCurrentChange = rest.onCurrentChange) === null || _rest$onCurrentChange === void 0 ? void 0 : _rest$onCurrentChange.call(rest, current);
    setStepCurrent(current);
  };

  var getDomList = function getDomList() {
    return genItems(columns, updateTime);
  };

  if (layoutType === 'StepsForm') {
    return /*#__PURE__*/React.createElement(StepsForm, _extends({
      formRef: formRef,
      onCurrentChange: onCurrentChange
    }, rest), steps === null || steps === void 0 ? void 0 : steps.map(function (item, index) {
      return /*#__PURE__*/React.createElement(BetaSchemaForm, _extends({}, item, {
        key: index,
        layoutType: "StepForm",
        columns: columns[index]
      }));
    }));
  }
  /** 如果是行内模式 */


  if (layoutType === 'Embed') return /*#__PURE__*/React.createElement(React.Fragment, null, getDomList());
  return /*#__PURE__*/React.createElement(Form, _extends({
    formRef: formRef
  }, rest, {
    onInit: function onInit() {
      var _rest$onInit;

      if (needRealUpdate) {
        updateFormRender(updateTime + 1);
      }

      for (var _len = arguments.length, restValue = new Array(_len), _key = 0; _key < _len; _key++) {
        restValue[_key] = arguments[_key];
      }

      rest === null || rest === void 0 ? void 0 : (_rest$onInit = rest.onInit) === null || _rest$onInit === void 0 ? void 0 : _rest$onInit.call.apply(_rest$onInit, [rest].concat(restValue));
    },
    onValuesChange: function onValuesChange() {
      var _rest$onValuesChange;

      if (needRealUpdate) {
        updateFormRender(updateTime + 1);
      }

      for (var _len2 = arguments.length, restValue = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        restValue[_key2] = arguments[_key2];
      }

      rest === null || rest === void 0 ? void 0 : (_rest$onValuesChange = rest.onValuesChange) === null || _rest$onValuesChange === void 0 ? void 0 : _rest$onValuesChange.call.apply(_rest$onValuesChange, [rest].concat(restValue));
    }
  }), getDomList());
}

export default BetaSchemaForm;